import { render, staticRenderFns } from "./style_s_2_control.vue?vue&type=template&id=2e93a9b6&scoped=true&"
import script from "./style_s_2_control.vue?vue&type=script&lang=js&"
export * from "./style_s_2_control.vue?vue&type=script&lang=js&"
import style0 from "./style_s_2_control.vue?vue&type=style&index=0&id=2e93a9b6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e93a9b6",
  null
  
)

export default component.exports